import tw from "twin.macro";

export type Mode = "dark" | "light";
export type Theme = "white" | "grey";

const style = {
  background: {
    white: {
      dark: tw`bg-grey-20-dark`,
      light: tw`bg-grey-20-light`,
    },
    grey: {
      dark: tw`bg-grey-40-dark`,
      light: tw`bg-grey-40-light`,
    },
  },
  text: {
    white: {
      dark: tw`text-black-100-dark`,
      light: tw`text-black-100-light`,
    },
    grey: {
      dark: tw`text-black-100-dark`,
      light: tw`text-black-100-light`,
    },
  },
  border: {
    white: {
      dark: tw`border-black-20-dark divide-black-20-dark`,
      light: tw`border-grey-40-dark/10 divide-grey-40-dark/10`,
    },
    grey: {
      dark: tw`border-black-20-dark divide-black-20-dark`,
      light: tw`border-black-20-light divide-black-20-light`,
    },
  },
  label: {
    white: {
      dark: tw`text-grey-100-dark/50`,
      light: tw`text-grey-100-light/50`,
    },
    grey: {
      dark: tw`text-grey-100-dark`,
      light: tw`text-grey-100-light`,
    },
  },
  outline: {
    white: {
      dark: tw`outline-black-20-dark`,
      light: tw`outline-grey-45-light`,
    },
    grey: {
      dark: tw`outline-black-20-dark`,
      light: tw`outline-black-20-light`,
    },
  },
} as const;

type Key = keyof typeof style;

type Props = {
  mode: Mode;
  theme?: Theme;
};

// Section settings come straight from Sanity, where stale or script-written
// values (e.g. theme "black") can bypass the Studio option list. An unknown
// key used to throw during render and 500 the whole page; fall back instead.
function resolveTheme(theme: unknown): Theme {
  return theme === "grey" ? "grey" : "white";
}

function resolveMode(mode: unknown): Mode {
  return mode === "dark" ? "dark" : "light";
}

export function getThemeStyle(props: Props) {
  const mode = resolveMode(props.mode);
  const theme = resolveTheme(props.theme);

  return (Object.keys(style) as Array<Key>).reduce((acc, key) => {
    return {
      ...acc,
      [key]: style[key][theme][mode],
    };
  }, {} as { [K in Key]: (typeof style)[K][Theme][Mode] });
}
